import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";
import IconWindowMaximize2 from "../../../../themes/icons/IconWindowMaximize2";

const id = "label1";
const idNext = "label2";

const next = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
            labels:
              - easy
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
            labels:
              - easy
          - choice: mountain
          - choice: lake
            labels:
              - easy
`;

const prev = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
`;

function ManualLabels1({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_globals") &&
        !document.getElementById("add_global_parameter") && (
          <div
            className={`${styles["container"]} ${styles["container-label1"]} ${styles["overlay"]}`}>
            <div id="tutorial-text-label1" className={`${styles["container__text"]}`}>
              <p>To show/hide global parameters click on the header.</p>
            </div>

            <Xarrow
              key={`arrow-1-${renderTrigger}`}
              start="tutorial-text-label1"
              end="header_globals"
              color="#415B32"
              strokeWidth={2}
              path="smooth"
              curveness={0.8}
              headSize={6}
            />
          </div>
        )}

      <div
        className={`${styles["foreground"]} ${styles["foreground-label1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Labels are an alternative way of grouping elements. Each choice, function and
              parameter may have one or more labels. Naturally, labels can be used in conditions.
            </p>
            <p>
              To see the meta panel, hover over it and click on the <IconWindowMaximize2 /> icon.
              Labels are separated by commas. Now, add a label <b>easy</b> to the <b>witch</b>{" "}
              choice. Afterwards, add the same label, i.e. <b>easy</b> to the following choices:{" "}
              <b>river</b>, <b>lake</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Start fresh!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateLabels1 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resLabelA, msg: msgLabelA } = tutorialUtils.validateLabels(root, "root→[function]→simple→[parameter]→foe→[choice]→witch", ["easy"]);

    if (!resLabelA) {
      setMessage(msgLabelA);
      return false;
    }

    let { res: resLabelB, msg: msgLabelB } = tutorialUtils.validateLabels(root, "root→[function]→simple→[parameter]→location→[choice]→river", ["easy"]);

    if (!resLabelB) {
      setMessage(msgLabelB);
      return false;
    }

     let { res: resLabelC, msg: msgLabelC } = tutorialUtils.validateLabels(root, "root→[function]→simple→[parameter]→location→[choice]→lake", ["easy"]);

    if (!resLabelC) {
      setMessage(msgLabelC);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return false;
  }

  return false;
};

export default ManualLabels1;
